export default __webpack_public_path__ + "static/media/img-0520-norway-full-face.20205a4e.png";